import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AccountPending() {
    const { user, logout } = useAuth();
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4 py-12" data-testid="account-pending-page">
            <div className="w-full max-w-md op-card p-8 op-fade-up text-center">
                <div className="op-label text-te8ff00">// ACCOUNT IN ATTESA</div>
                <h1 className="op-heading text-4xl mt-3">
                    {user?.status === "rejected" ? "Account rifiutato" : "Approvazione richiesta"}
                </h1>
                <p className="text-tc9ccd3 mt-4 leading-relaxed">
                    {user?.status === "rejected"
                        ? "Il tuo account è stato rifiutato dagli amministratori del CDP."
                        : "Il tuo account è in attesa di approvazione manuale da parte di un admin del CDP."}
                </p>
                <div className="flex gap-3 justify-center mt-6">
                    <Link to="/" className="op-btn" data-testid="pending-home-link">
                        Torna alla home
                    </Link>
                    <button onClick={logout} className="op-btn op-btn-ghost" data-testid="pending-logout-btn">
                        Esci
                    </button>
                </div>
            </div>
        </div>
    );
}
